
// 一维转二维数组
export const toTwoArray = (arr, num) => {
  const len = arr.length;
  const n = num;
  const lineNum = len % n === 0 ? len / n : Math.floor((len / n) + 1);
  const result = [];
  for (let i = 0; i < lineNum; i++) {
    const temp = arr.slice(i * n, i * n + n);
    result.push(temp);
  }
  return result;
};

export default {
  toTwoArray,
};
